import React from "react";
import PropTypes from "prop-types";
import { Container, Typography, Box } from "@mui/material";
import SearchBar from "../SearchBar/SearchBar";
import { useTheme } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  title: {
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center"
    }
  },
  root: {
    background: theme.palette.common.white,
    paddingBottom: theme.spacing(4),
    minHeight: "100vh"
  }
}));

function SearchPageLayout(props) {
  const { title, children, searchValue, onSearchSubmit, onSearchClear } = props;
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Container maxWidth="xl" className={classes.root}>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        mt={4}
      >
        <Box pr={4} flex={3} mb={5.5}>
          <Typography
            noWrap
            variant="h2"
            color="textSecondary"
            className={classes.title}
          >
            {title}
          </Typography>
        </Box>
        <Box flex={6} mb={5.5}>
          <SearchBar
            onSearchSubmit={onSearchSubmit}
            onSearchClear={onSearchClear}
            placeholder={title}
            disableUnderline={false}
            color={theme.palette.primary.main}
            value={searchValue}
          ></SearchBar>
        </Box>
      </Box>
      {children}
    </Container>
  );
}

export default SearchPageLayout;

SearchPageLayout.propTypes = {
  title: PropTypes.string,
  searchValue: PropTypes.any,
  children: PropTypes.node,
  onSearchSubmit: PropTypes.func,
  onSearchClear: PropTypes.func
};
